// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1408":"d9157c0ea88acd64","1583":"f24c77d2a6c9ed6a","3962":"e0370d9e10bc24ee","7292":"647c18b8b117ba2e"}[chunkId] + ".css";
};